
import { Tracker } from './tracker.model';

import { AbstractDetail } from '../abstract/abstract-detail.model';
import { Protocol } from '../protocol/protocol.model';
import { ProtocolSubmissionRule } from '../protocol/protocolSubmissionRule.model';
import { Section } from './section.model';
import { Note } from './note.model';


export class Evaluation {

  constructor(protocolId?: number,
    abstractId?: number,
    abstractProtocolId?: number,
    evaluationId?: number,
    evaluationTypeId?: number,
    submissionTypeId?: number,
    abstractStatusId?: number,
    abstract?: AbstractDetail,
    protocol?: Protocol,
    isComplete?: boolean,
    isRecommendedForReview?: boolean,
    submissions?: Array<Tracker>,
    protocolSubmissionRules?: Array<ProtocolSubmissionRule>,
    codingUISections?: Array<Section>,
    notes?: Array<Note>,
    teamSize?: number,
    isConsensusReady?: boolean,
    isMergeReady?: boolean,
    formTitle?: string,
    watchConsensusVisible?: boolean,
    startConsensusVisible?: boolean,
    startConsensusMergeVisible?: boolean,
    consensusStartedByYou?: boolean,
    currentSubmissionId?: number,
    teamMembers?: string,
    teamId?: number) {
    this.protocolId = protocolId;
    this.abstractId = abstractId;
    this.abstractProtocolId = abstractProtocolId;

    this.evaluationId = evaluationId;
    this.evaluationTypeId = evaluationTypeId;
    this.submissionTypeId = submissionTypeId;
    this.abstractStatusId = abstractStatusId;
    this.abstract = abstract;
    this.protocol = protocol;

    this.isComplete = isComplete;
    this.isRecommendedForReview = isRecommendedForReview;

    this.submissions = submissions;
    this.protocolSubmissionRules = protocolSubmissionRules;
    this.codingUISections = codingUISections;
    this.notes = notes;
    this.teamSize = teamSize;
    this.isConsensusReady = isConsensusReady;
    this.isMergeReady = isMergeReady;
    this.formTitle = formTitle;

    this.watchConsensusVisible = watchConsensusVisible;
    this.startConsensusVisible = startConsensusVisible;
    this.startConsensusMergeVisible = startConsensusMergeVisible;
    this.consensusStartedByYou = consensusStartedByYou;
    currentSubmissionId = currentSubmissionId;
    this.teamMembers = teamMembers;
    this.teamId = teamId;

  }

  public protocolId: number;
  public abstractId: number;

  public abstractProtocolId: number;
  public evaluationId: number;
  public evaluationTypeId: number;
  public submissionTypeId: number;
  public abstractStatusId: number;
  public abstract: AbstractDetail;
  public protocol: Protocol;

  public isComplete: boolean;
  public isConsensusReady: boolean;
  public isMergeReady: boolean;



  public isRecommendedForReview: boolean;
  public isRecommendedForAdjudication: boolean;

  public submissions: Array<Tracker> = [];
  public protocolSubmissionRules: Array<ProtocolSubmissionRule> = [];
  public codingUISections: Array<Section> = [];

  public notes: Array<Note> = [];

  public teamSize: number;

  public formTitle: string;

  public watchConsensusVisible: boolean;
  public startConsensusVisible: boolean;
  public startConsensusMergeVisible: boolean;
  public consensusStartedByYou: boolean;

  public currentSubmissionId: number;
  public teamMembers: string;
  public teamId: number;
}


